import { effects } from 'redux-saga'

import {
  loadProducts,
  loadOffers,
} from 'internal-components/src/redux/modules/product'

export default function* loadRequirements() {
  yield [effects.put.resolve(loadProducts()), effects.put.resolve(loadOffers())]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/loadRequirements.js